import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Spin from 'antd/lib/spin';
import { translate } from 'react-i18next';
import rules from '../../../common/rules/rules';
import accountRules from '../../../common/rules/accountRules';

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 14,
      offset: 6,
    },
    sm: {
      span: 14,
      offset: 6,
    },
  },
};

const formItemLayout = {
  labelCol: {
    xs: {
      span: 9,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 15,
    },
    sm: {
      span: 14,
    },
  },
};

@translate()
@Form.create()
export default class UserSettings extends Component {
  static propTyes = {
    t: PropTypes.func.isRequired,
    onChangePassword: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    isChangingPassword: PropTypes.bool.isRequired,
  };

  state = {
    repeatPasswordDirty: false,
  };

  handleSubmitPassword = e => {
    e.preventDefault();

    const { form, onChangePassword } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onChangePassword(values);
      }
    });
  };

  handleRepeatPasswordBlur = e => {
    const { repeatPasswordDirty } = this.state;

    this.setState({ repeatPasswordDirty: repeatPasswordDirty || !!e.target.value });
  };

  render() {
    const { isChangingPassword, form, t } = this.props;
    const { repeatPasswordDirty } = this.state;
    const { getFieldDecorator } = form;

    return (
      <Spin spinning={isChangingPassword}>
        <Form onSubmit={this.handleSubmitPassword}>
          <Form.Item {...tailFormItemLayout}>
            <h3>{t('Zmena hesla')}</h3>
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Staré heslo')}>
            {getFieldDecorator('passwordOld', { rules: rules.required })(
              <Input size="default" type="password" placeholder={t('Staré heslo')} />
            )}
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Nové heslo')}>
            {getFieldDecorator('password', {
              rules: [
                ...accountRules.passwordWithLimit,
                {
                  validator: accountRules.checkRepeatPassword(form, repeatPasswordDirty),
                },
              ],
            })(<Input size="default" type="password" placeholder={t('Nové heslo')} />)}
          </Form.Item>

          <Form.Item {...formItemLayout} label={t('Overenie nového hesla')}>
            {getFieldDecorator('repeatPassword', {
              rules: [
                ...accountRules.passwordWithLimit,
                {
                  validator: accountRules.checkPassword(form),
                },
              ],
            })(
              <Input
                size="default"
                type="password"
                placeholder={t('Overenie nového hesla')}
                onBlur={this.handleRepeatPasswordBlur}
              />
            )}
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit" size="small">
              {t('Odoslať')}
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/user-settings/components/UserSettings.js